// src/app/state/reducers/index.ts
import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../app.state';
import { organizationsReducer } from './organizations/core.reducer';
import { projectsReducer } from './organizations/projects.reducer';
import { specsReducer } from './organizations/specs.reducer';
import { markdownsReducer } from './organizations/markdowns.reducer';
import { organizationUsersReducer } from './organizations/users.reducer';
import { organizationInvitationsReducer } from './organizations/invitations.reducer';
import { organizationApiKeysReducer } from './organizations/apikeys.reducer';
import { organizationBillingHistoryReducer } from './organizations/billing-history.reducer';
import { organizationSupportReportsReducer } from './organizations/support.reducer';

// Import other reducers
import { authReducer } from './auth.reducer';
import { pricingReducer } from './pricing.reducer';
import { userReducer } from './user.reducer';
import { tryItReducer } from './try-it.reducer';
import { tryItRequestsReducer } from './try-it-requests.reducer';
import { sideMenuReducer } from './side-menu.reducer';
import { themeReducer } from './theme.reducer';
import { loadingReducer } from './loading.reducer';

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  theme: themeReducer,
  sideMenuVisibility: sideMenuReducer,
  isLoading: loadingReducer,
  user: userReducer,
  pricing: pricingReducer,
  tryIt: tryItReducer,
  tryItRequests: tryItRequestsReducer,
  
  // Organization reducers
  organizationApiKeys: organizationApiKeysReducer,
  organizationBillingHistory: organizationBillingHistoryReducer,
  organizations: organizationsReducer,
  organizationInvitations: organizationInvitationsReducer,
  projects: projectsReducer,
  specCheckResults: specsReducer,
  markdownCheckResults: markdownsReducer,
  organizationSupportReports: organizationSupportReportsReducer,
  organizationUsers: organizationUsersReducer,
};
